import { RootState } from '../types'

export const getSupportRequestsSelector = (state: RootState) => state.support.requests
export const getSupportSelector = (state: RootState) => state.support
